export const REQUEST_COMPANY_CLIENTS_CONTENT =
  "REQUEST_COMPANY_CLIENTS_CONTENT";
export const SET_COMPANY_CLIENTS_CONTENT = "SET_COMPANY_CLIENTS_CONTENT";
export const REVOKE_COMPANY_CLIENTS_CONTENT = "REVOKE_COMPANY_CLIENTS_CONTENT";
export const RESET_COMPANY_CLIENTS_CONTENT = "RESET_COMPANY_CLIENTS_CONTENT";

export const REQUEST_PERSON_CLIENTS_CONTENT = "REQUEST_PERSON_CLIENTS_CONTENT";
export const SET_PERSON_CLIENTS_CONTENT = "SET_COMPANY_PERSON_CONTENT";
export const REVOKE_PERSON_CLIENTS_CONTENT = "REVOKE_PERSON_CLIENTS_CONTENT";
export const RESET_PERSON_CLIENTS_CONTENT = "RESET_PERSON_CLIENTS_CONTENT";

export const CHANGE_CLIENTS_MODALS = "CHANGE_CLIENTS_MODALS";

export const SET_ACTIVE_CLIENT_DELETION = "SET_ACTIVE_CLIENT_DELETION";
export const RESET_ACTIVE_CLIENT_DELETION = "RESET_ACTIVE_CLIENT_DELETION";

export const SET_ACTIVE_CLIENT_DISPLAY = "SET_ACTIVE_CLIENT_DISPLAY";
export const RESET_ACTIVE_CLIENT_DISPLAY = "RESET_ACTIVE_CLIENT_DISPLAY";

export const REQUEST_UPDATE_SINGLE_CLIENT = "REQUEST_UPDATE_SINGLE_CLIENT";
export const REVOKE_UPDATE_SINGLE_CLIENT = "REVOKE_UPDATE_SINGLE_CLIENT";
export const RESET_UPDATE_SINGLE_CLIENT = "RESET_UPDATE_SINGLE_CLIENT";
export const GRANT_UPDATE_SINGLE_CLIENT = "GRANT_UPDATE_SINGLE_CLIENT";

export const REQUEST_DELETE_SINGLE_CLIENT = "REQUEST_DELETE_SINGLE_CLIENT";
export const REVOKE_DELETE_SINGLE_CLIENT = "REVOKE_DELETE_SINGLE_CLIENT";
export const RESET_DELETE_SINGLE_CLIENT = "RESET_DELETE_SINGLE_CLIENT";
export const GRANT_DELETE_SINGLE_CLIENT = "GRANT_DELETE_SINGLE_CLIENT";

export const REQUEST_ADD_SINGLE_CLIENT = "REQUEST_ADD_SINGLE_CLIENT";
export const REVOKE_ADD_SINGLE_CLIENT = "REVOKE_ADD_SINGLE_CLIENT";
export const RESET_ADD_SINGLE_CLIENT = "RESET_ADD_SINGLE_CLIENT";
export const GRANT_ADD_SINGLE_CLIENT = "GRANT_ADD_SINGLE_CLIENT";

export const REQUEST_SEARCH_SINGLE_CLIENT = "REQUEST_SEARCH_SINGLE_CLIENT";
export const REVOKE_SEARCH_SINGLE_CLIENT = "REVOKE_SEARCH_SINGLE_CLIENT";
export const RESET_SEARCH_SINGLE_CLIENT = "RESET_SEARCH_SINGLE_CLIENT";
export const GRANT_SEARCH_SINGLE_CLIENT = "GRANT_SEARCH_SINGLE_CLIENT";

export const APPEND_CLIENTS_DELETION_ARRAY = "APPEND_CLIENTS_DELETION_ARRAY";
export const SUBTRACT_CLIENTS_DELETION_ARRAY =
  "SUBTRACT_CLIENTS_DELETION_ARRAY";

export const REQUEST_DELETE_CLIENT_ARRAY = "REQUEST_DELETE_CLIENT_ARRAY";
export const REVOKE_DELETE_CLIENT_ARRAY = "REVOKE_DELETE_CLIENT_ARRAY";
export const RESET_DELETE_CLIENT_ARRAY = "RESET_DELETE_CLIENT_ARRAY";
export const GRANT_DELETE_CLIENT_ARRAY = "GRANT_DELETE_CLIENT_ARRAY";
